import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import '../styles/Pages.css';

const Settings: React.FC = () => {
  const { user } = useAuth();
  const [notifications, setNotifications] = useState({
    email: true,
    newFeatures: true,
    stories: false
  });
  const [theme, setTheme] = useState('light');
  const [saved, setSaved] = useState(false);

  const handleNotificationChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = e.target;
    setNotifications(prev => ({
      ...prev,
      [name]: checked
    }));
    setSaved(false);
  };

  const handleThemeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setTheme(e.target.value);
    setSaved(false);
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Mock API call to save settings
    setTimeout(() => {
      setSaved(true);
      // Reset saved status after 3 seconds
      setTimeout(() => setSaved(false), 3000);
    }, 600);
  };

  return (
    <div className="page-container">
      <h1 className="page-title">Settings</h1>
      
      <div className="settings-grid">
        <div className="settings-card">
          <h2 className="settings-section-title">Account Information</h2>
          <div className="settings-info-item">
            <span className="settings-label">Email</span>
            <span className="settings-value">{user?.email}</span>
          </div>
          <div className="settings-info-item">
            <span className="settings-label">Account Created</span>
            <span className="settings-value">{user?.created_at ? new Date(user.created_at).toLocaleDateString() : 'Unknown'}</span>
          </div>
        </div>

        <form className="settings-card" onSubmit={handleSubmit}>
          <h2 className="settings-section-title">Preferences</h2>
          
          <div className="settings-form-group">
            <label htmlFor="theme">Theme</label>
            <select 
              id="theme" 
              value={theme} 
              onChange={handleThemeChange}
              className="settings-select"
            >
              <option value="light">Light</option>
              <option value="dark">Dark</option>
              <option value="system">System Preference</option>
            </select>
          </div>
          
          <h3 className="settings-subsection-title">Notifications</h3>
          
          <div className="settings-form-group checkbox">
            <input 
              type="checkbox" 
              id="email" 
              name="email"
              checked={notifications.email}
              onChange={handleNotificationChange}
            />
            <label htmlFor="email">Email Notifications</label>
          </div>
          
          <div className="settings-form-group checkbox">
            <input 
              type="checkbox" 
              id="newFeatures" 
              name="newFeatures"
              checked={notifications.newFeatures}
              onChange={handleNotificationChange}
            />
            <label htmlFor="newFeatures">New Features and Updates</label>
          </div>
          
          <div className="settings-form-group checkbox">
            <input 
              type="checkbox" 
              id="stories" 
              name="stories"
              checked={notifications.stories}
              onChange={handleNotificationChange}
            />
            <label htmlFor="stories">Story Recommendations</label>
          </div>
          
          <div className="settings-actions">
            <button type="submit" className="action-button primary">Save Settings</button>
            {saved && <span className="settings-saved-message">Settings saved successfully!</span>}
          </div>
        </form>

        <div className="settings-card danger-zone">
          <h2 className="settings-section-title">Danger Zone</h2>
          <p className="danger-zone-description">These actions cannot be undone. Be careful!</p>
          
          <div className="danger-zone-actions">
            <button className="action-button outline-danger">Reset All Preferences</button>
            <button className="action-button danger">Delete Account</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings; 